import { useContext } from 'react';
import { SymbolContext } from '../symbol-context';

export type EmojiProps = { slug: string; emoji: string };

const Emoji = ({ emoji }: EmojiProps) => {
  const { sendEmoji } = useContext(SymbolContext);

  return (
    <button
      type='button'
      className='flex size-full desktop:text-5xl text-3xl select-none items-center justify-center hover:rounded-lg hover:bg-gray-800/25'
      onMouseDown={(e) => {
        e.preventDefault();
        sendEmoji(emoji);
      }}>
      {emoji}
    </button>
  );
};

export default Emoji;
